var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6665 3.66671H16.4998C16.9861 3.66671 17.4524 3.85986 17.7962 4.20368C18.14 4.54749 18.3332 5.01381 18.3332 5.50004V18.3334C18.3332 18.8196 18.14 19.2859 17.7962 19.6297C17.4524 19.9736 16.9861 20.1667 16.4998 20.1667H5.49984C5.01361 20.1667 4.54729 19.9736 4.20347 19.6297C3.85966 19.2859 3.6665 18.8196 3.6665 18.3334V5.50004C3.6665 5.01381 3.85966 4.54749 4.20347 4.20368C4.54729 3.85986 5.01361 3.66671 5.49984 3.66671H7.33317M8.24984 1.83337H13.7498C14.2561 1.83337 14.6665 2.24378 14.6665 2.75004V4.58337C14.6665 5.08963 14.2561 5.50004 13.7498 5.50004H8.24984C7.74358 5.50004 7.33317 5.08963 7.33317 4.58337V2.75004C7.33317 2.24378 7.74358 1.83337 8.24984 1.83337Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.904fd9e876c87fa951aeef72617e53f4.svg";
export { ForwardRef as ReactComponent };